// extracted by mini-css-extract-plugin
export var componentContainer = "Steps-module--component-container--aBwrL";
export var componentContainerInner = "Steps-module--component-container-inner--nXa7D";
export var componentTitle = "Steps-module--component-title--mPBnH";
export var stepContainer = "Steps-module--step-container--M8kzx";
export var stepDetails = "Steps-module--step-details--ozZeW";